var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":"/"}},[_c('v-img',{attrs:{"contain":"","width":"140px","src":_vm.logo,"title":`Logo ${_vm.$store.state.company.firm.long}`,"alt":`Logo ${_vm.$store.state.company.firm.long}`}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }